import React, { useEffect, useState } from "react";
// react-bootstrap components
import { Card, Form, Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { apiService } from "../../../service/ApiService";
import { notificationService } from "../../../service/NotificationService";
import CreateButton from "components/Buttons/CreateButton";
import EditButton from "components/Buttons/EditButton";
import GeneralStoreSelect from "components/DropDowns/GeneralStoreSelect";
import CategorySelect from "components/DropDowns/CategorySelect";
import ProductTypeSelect from "components/DropDowns/ProductTypeSelect";
import VatSelect from "components/DropDowns/VatSelect";
import VatExceptionCategorySelect from "components/DropDowns/VatExceptionCategorySelect";
import DishOrderSelect from "components/DropDowns/DishOrderSelect";
import MeasurementUnitSelect from "components/DropDowns/MeasurementUnitsSelect";

import { useTranslation } from "react-i18next";

function ProductPage() {
  const {
    t,
  } = useTranslation();

  const backRoute = "/admin/products";
  const history = useHistory();
  const { id } = useParams();
  const [storeId, setStoreId] = useState(null);
  const [productDocumentName, setProductDocumentName] = useState("");
  const [categoryId, setCategoryId] = useState(null);
  const [productName, setProductName] = useState("");
  const [productBarcode, setProductBarcode] = useState(null);
  const [productFontSize, setProductFontSize] = useState(15);
  const [productColor, setProductColor] = useState("#28c76f");
  const [productOrder, setProductOrder] = useState(0);
  const [productVatId, setProductVatId] = useState(null);
  const [dishOrderId, setDishOrderId] = useState(null);
  const [vatExceptionCategoryId, setVatExceptionCategoryId] = useState(null);
  const [measurementUnitId, setMeasurementUnitId] = useState(null);
  const [productTypeId, setProductTypeId] = useState(null);
  const [productPrice, setProductPrice] = useState(parseFloat(0).toFixed(2));
  const [productInventory, setProductInventory] = useState(0);
  const [productFreePrice, setProductFreePrice] = useState(false);
  const [productWeighed, setProductWeighed] = useState(false);
  const [deliveryFee, setDeliveryFee] = useState(false);
  const [integrationDefault, setIntegrationDefault] = useState(false);
  const [alwaysOpenExtra, setAlwaysOpenExtra] = useState(false);
  const [efoodId, setEfoodId] = useState(null);
  const [cards, setCards] = useState(null);
  const [openCards, setOpenCards] = useState(false);
  const [productDeleted, setProductDeleted] = useState(false);
  const [productIsSpecial, setProductIsSpecial] = useState(false);
  const [productInfo, setProductInfo] = useState(null);

  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const handleStoreId = (id) => {
    setStoreId(id);
  };

  const handleScroll = (e) => {
    e.target.blur();
  };

  useEffect(() => {
    if (!id) return;
    apiService
      .get(`api/v1/products/${id}`)
      .then((product) => {
        fillFields(product);
      })
      .catch((error) => {
        notificationService.notifyError(error.message);
        history.push(backRoute);
      });
  }, []);

  const handleInputNameChange = (e) => {
    setProductName(e.target.value);
    if (e.target.value.length <= 10) setProductDocumentName(e.target.value);
  };

  const handleInputDocNameChange = (e) => {
    if (e.target.value.length <= 10) setProductDocumentName(e.target.value);
  };

  const handleCategoryChange = (categoryId) => {
    setCategoryId(categoryId);
  };

  const handleProductType = (productTypeId) => {
    setProductTypeId(productTypeId);
  };

  const handleDishOrder = (dishOrderId) => {
    setDishOrderId(dishOrderId);
  };

  const handleProductVat = (productVatId) => {
    setProductVatId(productVatId);
    if (productVatId !== 7) setVatExceptionCategoryId(null);
    if (!productVatId) setVatExceptionCategoryId(null);
  };

  const handleProductVatExceptionCat = (vatExceptionCategoryId) => {
    setVatExceptionCategoryId(vatExceptionCategoryId);
  };

  const handleMeasurementUnit = (measurementUnitId) => {
    setMeasurementUnitId(measurementUnitId);
  };

  const handleProductWeighed = () => {
    setProductWeighed(!productWeighed);
    if (!productWeighed) setProductFreePrice(false);
  };

  const handleProductFreePrice = () => {
    setProductFreePrice(!productFreePrice);
    if (!productFreePrice) setProductWeighed(false);
  };

  const handlePriceChange = (event) => {
    const input = event.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(input)) setProductPrice(input);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setProductInfo((prev) => prev + "\n");
    }
  };

  const save = () => {
    setIsDisabled(true);
    const product = {
      name: productName,
      documentName: productDocumentName,
      barcode: productBarcode ? productBarcode : null,
      fontSize: productFontSize,
      color: productColor ? productColor : "ffffff",
      order: productOrder ? productOrder : 0,
      storeId: storeId,
      categoryId: categoryId,
      productTypeId: productTypeId,
      price: productPrice ? productPrice : 0,
      inventory: productInventory ? productInventory : 0,
      freePrice: productFreePrice,
      weighed: productWeighed,
      vatId: productVatId ? productVatId : null,
      deleted: productDeleted,
      vatExemptionCategoryId: vatExceptionCategoryId ? vatExceptionCategoryId : null,
      measurementUnitId: measurementUnitId ? measurementUnitId : null,
      dishOrderId: dishOrderId ? dishOrderId : null,
      deliveryFee: deliveryFee,
      integrationDefault: integrationDefault,
      alwaysOpenExtra: alwaysOpenExtra,
      efoodId: efoodId ? efoodId : null,
      cards: cards ? cards : null,
      openCards: openCards,
      info: productInfo ? productInfo.replace(/\n/g, ";") : null,
      isSpecial: productIsSpecial,
    };

    if (id) {
      apiService
        .putJson(`api/v1/products/${id}`, product)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.productSavedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    } else {
      apiService
        .postJson("api/v1/products", product)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.productCreatedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    }
  };

  const fillFields = (product) => {
    console.log(product);
    setProductName(product.name);
    setProductDocumentName(product.documentName);
    setProductBarcode(product.barcode);
    setProductFreePrice(product.freePrice);
    setProductWeighed(product.weighed);
    setProductPrice(product.price.toFixed(2));
    setProductFontSize(product.fontSize);
    setProductColor(product.color);
    setProductOrder(product.order);
    setProductDeleted(product.deleted);
    setProductInventory(product.inventory);
    setCategoryId(product.category.id);
    setProductTypeId(product.productType.id);
    setProductVatId(product.vat.id);
    setVatExceptionCategoryId(product.vatExemptionCategory ? product.vatExemptionCategory.id : null);
    setMeasurementUnitId(product.measurementUnit ? product.measurementUnit.id : null);
    setDishOrderId(product.dishOrder ? product.dishOrder.id : null);
    setDeliveryFee(product.deliveryFee);
    setIntegrationDefault(product.integrationDefault);
    setAlwaysOpenExtra(product.alwaysOpenExtra);
    setEfoodId(product.efoodId);
    setCards(product.cards);
    setOpenCards(product.openCards);
    setProductInfo(product.info ? product.info.replace(/;/g, "\n") : null);
    setProductIsSpecial(product.isSpecial);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="stacked-form">
              <Card.Header>
                <Card.Title as="h4">{id ? t("pages.titles.editProduct") : t("pages.titles.createProduct")}</Card.Title>
              </Card.Header>
              <Card.Body>
                {errorMessage ? <div style={{ color: "crimson" }}>{errorMessage}</div> : null}
                <Form action="#" method="#">
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>{t("common.labels.description")}</label>
                        <Form.Control
                          placeholder={t("common.labels.description")}
                          required={true}
                          type="text"
                          value={productName}
                          onChange={handleInputNameChange}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>{t("common.labels.documentDescription")}</label>
                        <Form.Control
                          placeholder={t("common.labels.documentDescription")}
                          required={true}
                          type="text"
                          value={productDocumentName}
                          onChange={handleInputDocNameChange}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label>Barcode</label>
                        <Form.Control
                          placeholder="Barcode"
                          required={true}
                          type="text"
                          value={productBarcode}
                          onChange={(event) => setProductBarcode(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>{t("common.labels.price")}</label>
                        <Form.Control
                          placeholder={t("common.labels.price")}
                          required={true}
                          type="number"
                          value={productPrice}
                          onChange={handlePriceChange}
                          step=".01"
                          min="0"
                          onWheel={handleScroll}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label>{t("common.labels.color")}</label>
                        <Form.Control
                          placeholder={t("common.labels.color")}
                          required={true}
                          type="color"
                          value={productColor}
                          onChange={(event) => setProductColor(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>{t("common.labels.order")}</label>
                        <Form.Control
                          placeholder={t("common.labels.order")}
                          required={true}
                          type="number"
                          value={productOrder}
                          onChange={(event) => setProductOrder(event.target.value)}
                          min="0"
                          onWheel={handleScroll}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label>{t("common.labels.fontSize")}</label>
                        <Form.Control
                          placeholder={t("common.labels.fontSize")}
                          required={true}
                          type="number"
                          value={productFontSize}
                          onChange={(event) => setProductFontSize(event.target.value)}
                          onWheel={handleScroll}
                          min="0"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>{t("common.labels.stock")}</label>
                        <Form.Control
                          placeholder={t("common.labels.stock")}
                          required={true}
                          type="number"
                          value={productInventory}
                          onChange={(event) => setProductInventory(event.target.value)}
                          min="0"
                          onWheel={handleScroll}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <CategorySelect title={t("common.labels.category")} defaultValue={categoryId} handler={handleCategoryChange} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <ProductTypeSelect title={t("messages.productType")} defaultValue={productTypeId} handler={handleProductType} />
                    </Col>
                    <Col md="6">
                      <MeasurementUnitSelect title={t("common.labels.measurementUnit")} defaultValue={measurementUnitId} handler={handleMeasurementUnit} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      {productVatId === 7 ? (
                        <Row>
                          <Col md="6">
                            <VatSelect title={t("tables.headers.vat")} defaultValue={productVatId} handler={handleProductVat} />
                          </Col>
                          <Col md="6">
                            <VatExceptionCategorySelect
                              title={t("common.labels.vatExemptionCategory")}
                              defaultValue={vatExceptionCategoryId}
                              handler={handleProductVatExceptionCat}
                            />
                          </Col>
                        </Row>
                      ) : (
                        <VatSelect title={t("tables.headers.vat")} defaultValue={productVatId} handler={handleProductVat} />
                      )}
                    </Col>
                    <Col md="6">
                      <DishOrderSelect title={t("common.labels.course")} defaultValue={dishOrderId} handler={handleDishOrder} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <GeneralStoreSelect title={t("common.labels.store")} disabled={true} selectedStoreId={handleStoreId} />
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label>{t("common.labels.cards")}</label>
                        <Form.Control
                          placeholder={t("common.labels.cards")}
                          required={true}
                          type="number"
                          value={cards}
                          onChange={(event) => setCards(event.target.value)}
                          min="0"
                          onWheel={handleScroll}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>{t("common.labels.information")}</label>
                        <Form.Control
                          as="textarea"
                          rows={6}
                          placeholder={t("common.labels.information")}
                          required={false}
                          value={productInfo}
                          onKeyDown={handleKeyPress}
                          onChange={(event) => setProductInfo(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-1" checked={productFreePrice} onChange={handleProductFreePrice} />
                          <span className="ml-1">{t("common.labels.openPrice")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-3" checked={productWeighed} onChange={handleProductWeighed} />
                          <span className="ml-1">{t("common.labels.weighedProduct")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-4" checked={deliveryFee} onChange={(e) => setDeliveryFee(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.deliveryCost")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check
                            type="switch"
                            id="switch-5"
                            checked={integrationDefault}
                            onChange={(e) => setIntegrationDefault(e.target.checked)}
                          />
                          <span className="ml-1">{t("common.labels.defaultForPlatforms")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-6" checked={alwaysOpenExtra} onChange={(e) => setAlwaysOpenExtra(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.showExtras")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check
                            type="switch"
                            id="switch-8"
                            checked={productIsSpecial}
                            onChange={(e) => setProductIsSpecial(e.target.checked)}
                          />
                          <span className="ml-1">Special</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-7" checked={openCards} onChange={(e) => setOpenCards(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.openCards")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-2" checked={productDeleted} onChange={(e) => setProductDeleted(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.inactive")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
                <Row className="float-right">
                  <Col>{id ? <EditButton handler={save} disabled={isDisabled} /> : <CreateButton handler={save} disabled={isDisabled} />}</Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ProductPage;
